import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import InteractiveText from "../../../components/common/Typography/InteractiveText";
import SpecialText from "../../../components/common/Typography/SpecialText";
import {
  PUBLIC_HELP_CENTRE_BLOCK_GAP_CLASS,
  PUBLIC_FAQ_ITEM_GAP_CLASS,
  PUBLIC_HEADING_ROW_GAP_CLASS,
} from "../../Public/shared/publicLayoutSpec";

const HelpCenterSection = () => {
  const { state = {} } = useLocation();
  const { section } = useParams();
  const navigate = useNavigate();
  const { dropdownTitle } = state;
  return (
    <div className="w-full">
      {dropdownTitle ? (
        <div className={`border-b border-b-mediumgray pb-4 ${PUBLIC_HELP_CENTRE_BLOCK_GAP_CLASS}`}>
          <button type="button" onClick={() => navigate(-1)}>
          <div className={`flex items-center justify-between ${PUBLIC_HEADING_ROW_GAP_CLASS}`}>
          <i class="fi fi-rr-undo-alt pb-1"></i>
            <SpecialText
              variant={"NavigationPath"}
              className={"text-offblack hover:text-primaryblue"}
            >
              {dropdownTitle}
            </SpecialText>
            </div>
          </button>
        </div>
      ) : (
        <div className={`border-b border-b-mediumgray pb-4 ${PUBLIC_HELP_CENTRE_BLOCK_GAP_CLASS}`}>
          <button type="button" onClick={() => navigate(-1)}>
            {/* <div className="flex items-center justify-between gap-1"> */}
            <SpecialText
              variant={"NavigationPath"}
              className={"text-offblack hover:text-primaryblue"}
            >
              <i class="fi fi-rr-undo-alt mr-2"></i>
              {state.title}
            </SpecialText>
            {/* </div> */}
          </button>
        </div>
      )}
      {state?.data?.map(
        ({
          heading,
          content,
          list,
          list2,
          list3,
          list4,
          list5,
          ListLabel,
          ListLabel2,
          ListLabel3,
          ListLabel4,
          ListLabel5,
          InlineHeadingList,
          FooterNote,
          FooterNote2,
          extraParagraph,
        }) => (
          <div className={PUBLIC_FAQ_ITEM_GAP_CLASS}>
            {heading && (
              <div
                onClick={() => {
                  navigate(`/HelpCentre/article/${section}`, {
                    state: {
                      ...state,
                      displayContent: content,
                      displayTitle: heading,
                      displayDropdowntitle: dropdownTitle,
                      displayList: list,
                      displayList2: list2,
                      displayList3: list3,
                      displayList4: list4,
                      displayList5: list5,
                      displayListLabel: ListLabel,
                      displayListLabel2: ListLabel2,
                      displayListLabel3: ListLabel3,
                      displayListLabel4: ListLabel4,
                      displayListLabel5: ListLabel5,
                      displayInlineHeadingList: InlineHeadingList,
                      displayFooterNote: FooterNote,
                      displayFooterNote2: FooterNote2,
                      displayExtraParagraph: extraParagraph,
                    },
                  });
                }}
              >
                <div className={`flex ${PUBLIC_HEADING_ROW_GAP_CLASS} cursor-pointer mb-4`}>
                  {/* <i className="fi fi-ss-bullet text-base text-offblack "></i> */}
                  <InteractiveText
                    variant={"FAQHeader"}
                    className="text-offblack hover:text-primaryblue cursor-pointer"
                  >
                    {heading}
                  </InteractiveText>
                </div>
              </div>
            )}
            <InteractiveText variant={"FAQAnswer"}>
              {content && content.slice(0, 100).concat("...")}
            </InteractiveText>
          
          </div>
        )
      )}
    </div>
  );
};

export default HelpCenterSection;
